import React, { useEffect, useState } from 'react'
import { IoMdArrowBack } from 'react-icons/io'
import { Link, useLocation, useNavigate } from 'react-router-dom'
import { FaRegCircleCheck } from "react-icons/fa6";
import { FaRegCircleXmark } from "react-icons/fa6";
import Button from 'react-bootstrap/Button';
import tickIcon from "../../assets/svg/Tick Square.svg"
import closeIcon from "../../assets/svg/Close Square.svg"
import { approveOrder, deleteOrderProduct, getOrderDetails, rejectOrder, shipOrder } from '../../api/context/orders';
import moment from 'moment';
import { Table } from 'react-bootstrap';
import toast from 'react-hot-toast';
import { FaDownload } from "react-icons/fa6";
import Loader from '../../components/loader/loader';
import { checkUserPermissions } from '../../helpers/permission';

const PaymentDetails = () => {

    const location = useLocation();
    const state = location.state;

    const orderData = state?.paymentDetails?.Order

    console.log(orderData, 'Payment');

    const [loading, setLoading] = useState(false)



    const UnmaskedUserDetails = () => {
        return (<>
            <Table>
                <tbody>
                    <tr>
                        <td className='user-details-subheading'>User Name:</td>
                        <td className='user-details-data'>
                            {orderData?.Address?.customerName ? `${orderData.Address.customerName}` : "N/A"}</td>
                    </tr>
                    <tr>
                        <td className='user-details-subheading'>Mobile Number:</td>
                        <td className='user-details-data'>
                            {orderData?.Address?.customerMobile ? `${orderData.Address.customerMobile}` : "N/A"}
                        </td>
                    </tr>
                    <tr>
                        <td className='user-details-subheading'>Email Address:</td>
                        <td className='user-details-data'>{orderData?.Address?.customerEmail ? orderData?.Address?.customerEmail : 'N/A'}</td>
                    </tr>
                    <tr>
                        <td className='user-details-subheading'>Address: </td>
                        <td className='user-details-data'>
                            <div>{orderData?.Address?.line1 + ',' + orderData?.Address?.postalCode}</div>
                            <div>{orderData?.Address?.city + ',' + orderData?.Address?.state + ',' + orderData?.Address?.country}</div>
                        </td>
                    </tr>
                </tbody>
            </Table>
        </>)
    }

    const MaskedUserDetails = () => {
        return (<>
            <Table>
                <tbody>
                    <tr>
                        <td className='user-details-subheading'>User Name:</td>
                        <td className='user-details-data'>
                            {orderData?.Address?.customerName ? `${orderData.Address.customerName.charAt(0) + `****`}` : "N/A"}</td>
                    </tr>
                    <tr>
                        <td className='user-details-subheading'>Mobile Number:</td>
                        <td className='user-details-data'>
                            {orderData?.Address?.customerMobile ? `${orderData.Address.customerMobile.slice(0, 3) + `*******`}` : ""}
                        </td>
                    </tr>
                    <tr>
                        <td className='user-details-subheading'>Email Address:</td>
                        <td className='user-details-data'>{orderData?.Address?.customerEmail ? `${orderData?.Address?.customerEmail.slice(0, 3) + `*******`}` : '*****@gmail.com'}</td>
                    </tr>
                    <tr>
                        <td className='user-details-subheading'>Address: </td>
                        <td className='user-details-data'>
                            <div>{orderData?.Address?.line1 + ',' + orderData?.Address?.postalCode}</div>
                            <div>{orderData?.Address?.city + ',' + orderData?.Address?.state + ',' + orderData?.Address?.country}</div>
                        </td>
                    </tr>
                </tbody>
            </Table>
        </>)
    }



    return (
        <div className='order_details_wrapper'>
            {loading ? (
                <Loader />
            ) : (
                <div className="row">
                    <div className="col-12">
                        <div className="page-title-box d-sm-flex align-items-center">
                            <Link to='/payments' className='back_btn_wrap'>
                                <IoMdArrowBack className='icon' />
                            </Link>
                            <h4 className="mb-sm-0">Payment Details</h4>
                        </div>
                    </div>
                    <div className='col-12 '>
                        <div className='new-class'>
                            <div className='order_flex_wrapper'>
                                <div className='order_contents'>
                                    <h4>Transaction Id: {orderData?.razorpayOrderId ? orderData?.razorpayOrderId : "N/A - (COD)"}</h4>
                                    <p>{moment(orderData?.createdAt).format('DD/MM/YYYY, hh:mm a')}</p>
                                </div>
                            </div>
                            <div className='user_details_wrapper'>
                                <div className='row'>
                                    <div className='col-lg-6'>
                                        <div className='user_details'>
                                            <h4>
                                                User Details
                                            </h4>
                                            {checkUserPermissions("admin") ? <UnmaskedUserDetails /> : <MaskedUserDetails />}
                                        </div>
                                    </div>
                                    <div className='col-sm-12 col-lg-6'>
                                        <div className='user_details'>
                                            <h4>
                                                Order Details
                                            </h4>
                                            <Table>
                                                <tbody>
                                                    {orderData?.paymentMode &&
                                                        <tr>
                                                            <td className='user-details-subheading'>Payment Mode:</td>
                                                            <td className='user-details-data'>{orderData?.paymentMode}</td>
                                                        </tr>
                                                    }
                                                    {orderData?.billingAmount &&
                                                        <tr>
                                                            <td className='user-details-subheading'>Amount:</td>
                                                            <td className='user-details-data'>Rs. {orderData?.billingAmount}/-</td>
                                                        </tr>
                                                    }
                                                    {orderData?.paymentStatus &&
                                                        <tr>
                                                            <td className='user-details-subheading'>Payment Status:</td>
                                                            <td className='user-details-data'>{orderData?.paymentStatus}</td>
                                                        </tr>
                                                    }
                                                    {orderData?.razorpayOrderId &&
                                                        <tr>
                                                            <td className='user-details-subheading'>Razorpay Order ID:</td>
                                                            <td className='user-details-data'>{orderData?.razorpayOrderId}</td>
                                                        </tr>
                                                    }
                                                    {orderData?.shipRocketOrderId &&
                                                        <tr>
                                                            <td className='user-details-subheading'>Shipment Order ID:</td>
                                                            <td className='user-details-data'>{orderData?.shipRocketOrderId}</td>
                                                        </tr>
                                                    }
                                                    {orderData?.shiprocketShipmentId &&
                                                        <tr>
                                                            <td className='user-details-subheading'>Shipment ID:</td>
                                                            <td className='user-details-data'>{orderData?.shiprocketShipmentId}</td>
                                                        </tr>
                                                    }
                                                </tbody>
                                            </Table>
                                        </div>
                                    </div>
                                    <div className='col-sm-12 col-lg-6'>
                                        <div className='user_details'>
                                            <h4>
                                                Vendor Details
                                            </h4>
                                            <Table>
                                                <tbody>
                                                    <tr>
                                                        <td className='user-details-subheading'>Store Name:</td>
                                                        <td className='user-details-data'>{orderData?.orderProducts?.[0]?.Product?.manufacturer?.storeName}</td>
                                                    </tr>
                                                    <tr>
                                                        <td className='user-details-subheading'>Mobile Number:</td>
                                                        <td className='user-details-data'>{orderData?.orderProducts?.[0]?.Product?.manufacturer?.phoneNumber}</td>
                                                    </tr>
                                                    <tr>
                                                        <td className='user-details-subheading'>Email Address:</td>
                                                        <td className='user-details-data'>{orderData?.orderProducts?.[0]?.Product?.manufacturer?.email}</td>
                                                    </tr>
                                                    <tr>
                                                        <td className='user-details-subheading'>Address: </td>
                                                        <td className='user-details-data'>
                                                            <div>{orderData?.orderProducts?.[0]?.Product?.manufacturer?.address + ',' + orderData?.orderProducts?.[0]?.Product?.manufacturer?.landmark}</div>
                                                            <div>{orderData?.orderProducts?.[0]?.Product?.manufacturer?.city + ',' + orderData?.orderProducts?.[0]?.Product?.manufacturer?.state}</div>
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </Table>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            )}
        </div>
    )
}

export default PaymentDetails

